import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Auth, I18n } from 'aws-amplify'
import { useAlert } from 'react-alert'

import { useForm } from '../../../hooks'
import { exceptionsError, goToUrl } from '../../../utils'
import { Button, Input } from '../../../components'
import { CardContainer } from '../../../components/ui/components'

import { ArrowRightSvg, FullLogoSvg } from '../../../assets/icons/svgComponents'

import * as S from './styles'

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const alert = useAlert()
  const email = useForm('email')

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      if (email.value) {
        setLoading(true)
        await Auth.forgotPassword(email.value)
        alert.show(I18n.get('ForgotPasswordExceptionCodeSendingSuccess'), {
          type: 'success',
          timeout: 4000
        })
        history.push({
          pathname: '/recuperar-senha',
          search: history.location.search,
          state: {
            email: email.value
          }
        })
      }
    } catch (error: any) {
      if (
        error.code === 'UserNotConfirmedException' ||
        error.code === 'UserLambdaValidationException'
      ) {
        goToUrl(history, '/confirmar-usuario', {
          email: email.value
        })
      } else if (
        error.message ===
        'Custom auth lambda trigger is not configured for the user pool.'
      ) {
        alert.show(I18n.get('ForgotPasswordExceptionContactVerifiedRequired'), {
          type: 'error',
          timeout: 4000
        })
      } else if (error.code === 'InvalidParameterException') {
        alert.show(I18n.get('InvalidParameterException'), {
          type: 'error',
          timeout: 4000
        })
        // goToUrl(history, "/confirmar-email", { email: email.value })
      } else {
        alert.show(exceptionsError(error.code, error.message), {
          type: 'error',
          timeout: 4000
        })
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <S.Wrapper>
      <CardContainer style="container">
        <S.Content>
          <FullLogoSvg
            colorX="#00995D"
            colorLetters="#6F6F6E"
            width="182"
            height="42"
          />
          <S.Subtitle>Seja bem-vindo(a)!</S.Subtitle>
          <S.Description>Recupere sua senha</S.Description>
          <form onSubmit={onSubmit}>
            <Input
              onKeyUp={() => email.validate()}
              labelColor="#4F4F4F"
              label="E-mail"
              type="email"
              name="email"
              {...email}
            />
            <S.ButtonContainer>
              {loading ? (
                <Button
                  disabled
                  endIcon={<ArrowRightSvg className="icon-arrow-right" />}
                >
                  Enviando...
                </Button>
              ) : (
                <Button
                  endIcon={<ArrowRightSvg className="icon-arrow-right" />}
                >
                  Enviar
                </Button>
              )}
            </S.ButtonContainer>
          </form>
        </S.Content>
      </CardContainer>
    </S.Wrapper>
  )
}
export default ForgotPassword
